// extracted by mini-css-extract-plugin
export var brand = "_bx-9";
export var compact = "_bx-6";
export var extraSmall = "_bx-7";
export var icon = "_bx-0";
export var large = "_bx-4";
export var light = "_bx-1";
export var medium = "_bx-5";
export var outline = "_bx-b";
export var primaryDark = "_bx-a";
export var primaryLight = "_bx-8";
export var primaryModern = "_bx-c";
export var success = "_bx-2";
export var successSolid = "_bx-3";